/* Renders PayPal Pay Later checkout for any .adv-paylater[data-paypal-amount] on the page.
   Loads the PayPal SDK once, on demand. Used on product pages and product grids.
   Logic mirrors the bundle checkout reference: Pay Later messaging + a standalone
   Pay Later button, with a fallback to a default PayPal button when Pay Later
   isn't eligible for the buyer. */
(function () {
  var SDK = "https://www.paypal.com/sdk/js?client-id=AZfqzoxgQFfMRk2LRhMD_-yBwknpdi6wlOGTulqBzmusaESwlrSQ440_92FEWCk6hjb5lZPnjH4cI82a&components=buttons,funding-eligibility,messages&currency=USD&enable-funding=paylater";
  var loading = false, waiters = [];

  function loadSDK(cb) {
    if (window.paypal && window.paypal.Buttons) { cb(); return; }
    waiters.push(cb);
    if (loading) return;
    loading = true;
    var s = document.createElement('script');
    s.src = SDK;
    s.onload = function () { waiters.forEach(function (f) { f(); }); waiters = []; };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
  }

  function statusUpdate(box, text, ok) {
    if (!box) return;
    box.textContent = text;
    box.style.display = 'block';
    box.style.backgroundColor = ok ? '#E6F4EA' : '#FCE8E6';
    box.style.color = ok ? '#137333' : '#C5221F';
  }

  function renderOne(el) {
    if (el.getAttribute('data-pp-done')) return;
    el.setAttribute('data-pp-done', '1');
    var amount = el.getAttribute('data-paypal-amount');
    var compact = el.getAttribute('data-paypal-compact') === 'true';
    var msg = el.querySelector('.adv-paylater__msg');
    var btn = el.querySelector('.adv-paylater__btn');
    var status = el.querySelector('.adv-paylater__status');

    // 1. Pay Later promo messaging (hidden on compact grid cards)
    if (!compact && window.paypal.Messages && msg) {
      paypal.Messages({ amount: amount, placement: 'product' }).render(msg);
    }

    if (!window.paypal.Buttons) return;

    function makeOrder(d, a) { return a.order.create({ purchase_units: [{ amount: { value: amount } }] }); }
    function onApprove(d, a) {
      return a.order.capture().then(function (det) {
        statusUpdate(status, "✓ Success! Paid by " + det.payer.name.given_name, true);
      });
    }
    function onErr(e) { console.error(e); statusUpdate(status, "⚠ Error during checkout.", false); }

    // Main-page grid cards: PayPal button whose text reads "Buy Now".
    if (compact) {
      paypal.Buttons({
        style: { layout: 'vertical', shape: 'rect', color: 'gold', label: 'buynow', height: 48, tagline: false },
        createOrder: makeOrder,
        onApprove: onApprove,
        onError: onErr
      }).render(btn);
      return;
    }

    // 2. Standalone Pay Later button
    var payLaterBtn = paypal.Buttons({
      fundingSource: paypal.FUNDING.PAYLATER,
      style: { layout: 'vertical', shape: 'rect', color: 'gold', label: 'pay', height: 48 },
      createOrder: makeOrder,
      onApprove: onApprove,
      onError: onErr
    });

    // 3. Fall back to a default PayPal button if Pay Later isn't eligible for this buyer
    if (payLaterBtn.isEligible()) {
      payLaterBtn.render(btn);
    } else {
      paypal.Buttons({
        style: { layout: 'vertical', shape: 'rect', color: 'gold', label: 'pay', height: 48 },
        createOrder: makeOrder,
        onApprove: onApprove,
        onError: onErr
      }).render(btn);
    }
  }

  // Standalone PayPal Wallet button (pay with PayPal account/balance)
  function renderWallet(el) {
    if (el.getAttribute('data-pp-done')) return;
    el.setAttribute('data-pp-done', '1');
    var amount = el.getAttribute('data-paypal-amount');
    var btn = el.querySelector('.adv-ppwallet__btn');
    var status = el.querySelector('.adv-ppwallet__status');
    if (!window.paypal || !window.paypal.Buttons) return;

    function makeOrder(d, a) { return a.order.create({ purchase_units: [{ amount: { value: amount } }] }); }
    function onApprove(d, a) {
      return a.order.capture().then(function (det) {
        statusUpdate(status, "✓ Success! Paid by " + det.payer.name.given_name, true);
      });
    }
    function onErr(e) { console.error(e); statusUpdate(status, "⚠ Error during checkout.", false); }

    paypal.Buttons({
      fundingSource: paypal.FUNDING.PAYPAL,
      style: { layout: 'vertical', shape: 'rect', color: 'gold', label: 'paypal', height: 48 },
      createOrder: makeOrder,
      onApprove: onApprove,
      onError: onErr
    }).render(btn);
  }

  function renderAll() {
    var els = document.querySelectorAll('.adv-paylater[data-paypal-amount]:not([data-pp-done])');
    var wallets = document.querySelectorAll('.adv-ppwallet[data-paypal-amount]:not([data-pp-done])');
    if (!els.length && !wallets.length) return;
    loadSDK(function () {
      Array.prototype.forEach.call(els, renderOne);
      Array.prototype.forEach.call(wallets, renderWallet);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
  document.addEventListener('shopify:section:load', renderAll);
})();





/* Fix wording in the Easify options message */
(function () {
  function swap(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf('Your selections will') !== -1) {
        n.nodeValue = n.nodeValue.replace('Your selections will', 'Your selection will');
      }
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    swap(document.body);
    new MutationObserver(function () { swap(document.body); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();



/* PayPal express button on the Pitt product page — routes through Shopify checkout */
(function () {
if (['/products/pitt-community-college',
     '/products/downey-voice-writing-student-bundle-with-16-inch-laptop-copy',
     '/products/downey-voice-writing-student-bundle-with-14-inch-laptop',
     '/products/downey-voice-writing-student-bundle-with-16-inch-laptop'].indexOf(location.pathname) === -1) return;

  function setup() {
    var form = document.querySelector('.adv-pp__form');
    if (!form || document.querySelector('.adv-ppexpress')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'adv-ppexpress';
    btn.setAttribute('aria-label', 'Check out with PayPal');
    btn.style.cssText = 'display:flex;align-items:center;justify-content:center;width:100%;max-width:420px;height:48px;margin-top:0.9rem;background:#FFC439;border:0;border-radius:4px;cursor:pointer;';
    btn.innerHTML = btn.innerHTML = '<img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png" alt="PayPal" style="height:24px;margin-right:8px"><span style="font-weight:700;font-size:16px;color:#003087">Pay Later</span>';

    var shopBtn = form.querySelector('.shopify-payment-button');
    if (shopBtn) { form.insertBefore(btn, shopBtn); } else { form.appendChild(btn); }

    btn.addEventListener('click', function () {
      btn.disabled = true; btn.style.opacity = '0.7';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add to cart failed');
          window.location.href = '/checkout?skip_shop_pay=true';
        })
        .catch(function (e) {
          console.error(e);
          btn.disabled = false; btn.style.opacity = '1';
          alert('Could not start checkout. Please use Add to Cart.');
        });
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setup); } else { setup(); }
})();